<template>
       <div>
            <div class="holster">
				<div class="container x mandatory-scroll-snapping" dir="ltr">
					<div id="card-1" class="p-3 ml-3 border border-light rounded shadow">					
						<!-- image -->
						<content class="d-flex flex-column justify-content-center">
							<div class="">
								<img style="height: 30vh" src="@/assets/svgs/undraw_welcome_3gvl.svg" alt="">
							</div>
							<div>
								<h3 class="font-weight-bold">Welcome to vidduka</h3>
								<p class="p-5">
									Digitize your retail enterprise withour  P.O.S, revenue tracking, 
									purchase order management and inventory levels monitor
								</p>
							</div>
							<div class="d-flex justify-content-center">
								<button @click="moveToCard(2)" class="btn btn-outline-success btn-sm">next</button>
							</div>
						</content>					
					</div>
					<!-- tab 2 -->
					<div id="card-2" class="p-3 ml-3 border border-light rounded shadow">					
						<!-- image -->
						<content class="d-flex flex-column justify-content-center">
							<div class="">
								<img style="height: 30vh" src="@/assets/svgs/undraw_data_reports_706v.svg" alt="">
							</div>
							<div>
								<h3 class="font-weight-bold">Inventory monitor</h3>
								<p class="p-5">
									Avoid surprises on your premise by products being out of stock, Get to know what is on stock, 
									out of stock and those almost getting depleted
								</p>
							</div>
							<div class="d-flex justify-content-center">
								<button class="btn btn-outline-success border-0 btn-sm" @click="moveToCard(1)">previous</button>
								<button class="ml-2 btn btn-outline-success btn-sm" @click="moveToCard(3)">next</button>
							</div>
						</content>					
					</div>

					<!-- tab 3 -->
					<div id="card-3" class="p-3 ml-3 border border-light rounded shadow">					
							<!-- image -->
							<content class="d-flex flex-column justify-content-center">
								<div class="">
									<img style="height: 30vh" src="@/assets/svgs/undraw_predictive_analytics_kf9n.svg" alt="">
								</div>
								<div>
									<h3 class="font-weight-bold">Sales reporting</h3>
									<p class="p-5">
										Generate all the essential reports on sales and know the flow of your business,
										Daily sales reports , user marigin reports, gross profits and so much more.
									</p>
								</div>
								<div class="d-flex justify-content-center">
									<button class="btn btn-outline-success border-0 btn-sm" @click="moveToCard(2)">previous</button>
									<button class="ml-2 btn btn-outline-success btn-sm" @click="moveToCard(4)">next</button>
								</div>
							</content>					
					</div>					

					<!-- tab 4 -->
					<div id="card-4" class="p-3 ml-3 border border-light rounded shadow">					
							<!-- image -->
							<content class="d-flex flex-column justify-content-center">
								<div class="">
									<img style="height: 30vh" src="@/assets/svgs/undraw_revenue_3osh.svg" alt="">
								</div>
								<div>
									<h3 class="font-weight-bold">Revenue tracking</h3>
									<p class="p-5">
										One more thing...
										Track your revenue per type: Mobile money,Cash and those made on credit
									</p>
								</div>
								<div class="d-flex justify-content-center">
									<button class="btn btn-outline-success border-0 btn-sm" @click="moveToCard(3)">previous</button>
									<button class="ml-2 btn btn-outline-success btn-sm" @click="goto('login')">login</button>
								</div>
							</content>					
					</div>
					
			</div>
                  
            </div>
       </div>
</template>
<script>
    export default {
        name: 'on-boarding',
        props: {
            msg: String
        },
        data(){
            return{
                search:null,            
            }
        },
        mounted(){            

        },
        watch:{
        },
        methods:{	
			goto: function(route_name){
				this.$router.push(route_name)
			},	
            moveToCard: function(id){
                document.getElementById(`card-${id}`).scrollIntoView({behavior: "smooth"})
            }
        }
    }
</script>
<style>
    /* setup */
html, body, .holster {
  height: 100%;
}
.holster {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: column nowrap;  
}

.container {
  display: flex;
  overflow: auto;
  flex: none;
}

.container.x {
	overflow-x: hidden;	
	width: 100%;
	height: 75vh;
	flex-flow: row nowrap;
}

/* scroll-snap */
.x.mandatory-scroll-snapping {
  scroll-snap-type: x mandatory;
}

.container > div {
  text-align: center;
  scroll-snap-align: center;
  flex: none;
}

.x.container > div {
  width: 70%;
  height: 70vh;
}

/* coloration */
</style>